import { Navigate, useRoutes } from "react-router-dom";
import config from "../config";
import CustomerPortalRoutes from "../modules/customer-portal/routes/CustomerPortalRoutes";

export default function ThemeRoutes() {
  return useRoutes([
    { path: "/", element: <Navigate to="/login" replace /> },
    { path: config.basePath + "/", element: <Navigate to={config.defaultPath} replace /> },
    CustomerPortalRoutes,
    { path: "*", element: <Navigate to="/login" replace /> },
  ]);
}
